// extracted by mini-css-extract-plugin
export default {"card":"I5-z"};